import { ChangeDetectorRef, Component, ElementRef, Injectable, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';

import * as _ from 'lodash';
import { AdminAccountService } from '../../../../../common/services/admins/account.service';
import { AccountConst, ListConfigAccount } from './account.const';
import { TableAction } from '../../../../../components/table-component/table.const';
import { BaseListComponent } from '../../../../../components/base-list.component';
import { generateKey } from '../../../../../common/utils/common';
import { FormFieldType, ModalType } from '../../../../../components/modals/modal-form-template/modal-form.const';
import { isEmail } from '../../../../../common/utils/validate';
import { saveAs } from 'file-saver';

declare var $: any;

@Component({
  moduleId: module.id,
  selector: 'account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.css', '../switchboard/switchboard.component.css'],
  providers: [AdminAccountService, BsModalService],
})
@Injectable()
export class AccountComponent extends BaseListComponent {
  @ViewChild('templateAccount') templateAccount: ElementRef;

  public modelFilter: any = {};
  public targetTenant: any = {};
  public isConfig = false;
  public tabList: any = [
    { id: ListConfigAccount.SipTrunk, title: 'Cấu hình sip trunk' },
    { id: ListConfigAccount.User, title: 'Chuyên viên' },
  ];
  public currentTab = ListConfigAccount.SipTrunk;
  protected readonly ListConfigAccount = ListConfigAccount;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private accountService: AdminAccountService
  ) {
    super(changeDetector, toastr, modalService);
    this.currentTab = ListConfigAccount.SipTrunk;
    this.displayColumns = AccountConst.displayColumns();
  }

  async ngOnInit() {
    await this.loadData();
  }

  onChangeTab(id) {
    this.currentTab = id;
  }

  async loadData(request: any = {}, sort: any = {}) {
    this.data = [];
    const payload = await this.buildBasePayload(request, sort);
    this.accountService.list(payload).subscribe(
      res => {
        if (res.status == 200 && res.error == false) {
          this.data = res.data.list;
          this.data = this.data.map(res => {
            res.display_active = AccountConst.displayActiveColumn(res);
            res.status = res.active;
            return res;
          });
          this.initPage(res.data.total);
        } else {
          this.throwError(res.message);
        }
      },
      err => {
        this.throwError(err.message);
        this.data = [];
      }
    );
  }

  async resetSecretkey() {
    this.model.secretkey = generateKey(32);
    await this.setUpModel(this.typeModal);
  }

  setUpModel(type) {
    this.typeModal = type;
    this.modelContent = {
      type: ModalType.Primary,
      title: this.typeModal === 'add' ? 'Thêm mới khách hàng doanh nghiệp' : 'Cập nhật khách hàng doanh nghiệp',
      submit_title: this.typeModal === 'add' ? 'Thêm mới' : 'Cập nhật',
    };
    this.modelDisplay = [
      {
        key: 'name',
        label: 'Tên khách hàng',
        type: FormFieldType.Text,
        value: this.model.name,
        required: true,
        disabled: false,
        width: 'full',
        order: 0,
      },
      {
        key: 'domain',
        label: 'Tên domain',
        type: FormFieldType.Text,
        value: this.model.domain,
        required: true,
        disabled: this.typeModal === 'edit',
        width: '1/2',
        order: 1,
      },
      {
        key: 'email',
        label: 'Email đăng nhập',
        type: FormFieldType.Text,
        value: this.model.email,
        required: true,
        disabled: this.typeModal === 'edit',
        width: '1/2',
        order: 2,
      },
      {
        key: 'limited',
        label: 'Số lượng chuyên viên tối đa',
        type: FormFieldType.Number,
        value: this.model.limited,
        required: true,
        disabled: false,
        width: '1/2',
        customAfter: { title: 'User' },
        order: 3,
      },
      {
        key: 'ring_duration',
        label: 'Thời gian ring tối đa',
        type: FormFieldType.Number,
        value: this.model.ring_duration,
        required: false,
        disabled: false,
        width: '1/2',
        customAfter: { title: 'Giây' },
        order: 4,
      },
      {
        key: 'max_outbound',
        label: 'Số cuộc gọi tối đa Inbound',
        type: FormFieldType.Number,
        value: this.model.max_inbound,
        required: false,
        disabled: false,
        width: '1/2',
        customAfter: { title: 'Cuộc' },
        order: 5,
      },
      {
        key: 'max_inbound',
        label: 'Số cuộc gọi tối đa Outbound',
        type: FormFieldType.Number,
        value: this.model.max_outbound,
        required: false,
        disabled: false,
        width: '1/2',
        customAfter: { title: 'Cuộc' },
        order: 6,
      },
      {
        key: 'inbound_duration',
        label: 'Thời lượng cuộc gọi inbound tối đa',
        type: FormFieldType.Number,
        value: this.model.inbound_duration,
        required: false,
        disabled: false,
        width: '1/2',
        customAfter: { title: 'Phút' },
        order: 7,
      },
      {
        key: 'outbound_duration',
        label: 'Thời lượng cuộc gọi outbound tối đa',
        type: FormFieldType.Number,
        value: this.model.outbound_duration,
        required: false,
        disabled: false,
        width: '1/2',
        customAfter: { title: 'Phút' },
        order: 8,
      },
      {
        key: 'duration',
        label: 'Thời lượng tối đa 1 cuộc outbound',
        type: FormFieldType.Number,
        value: this.model.duration,
        required: false,
        disabled: false,
        width: '1/2',
        customAfter: { title: 'Phút' },
        order: 9,
      },
      {
        key: 'max_duration_out',
        label: 'Thời lượng tối đa 1 cuộc inbound',
        type: FormFieldType.Number,
        value: this.model.max_duration_out,
        required: false,
        disabled: false,
        width: '1/2',
        customAfter: { title: 'Phút' },
        order: 10,
      },
      {
        key: 'webhook',
        label: 'Webhook',
        type: FormFieldType.Text,
        value: this.model.webhook,
        required: false,
        disabled: false,
        width: 'full',
        order: 11,
      },
      {
        key: 'crmurl',
        label: 'Crm URL',
        type: FormFieldType.Text,
        value: this.model.crmurl,
        required: false,
        disabled: false,
        width: 'full',
        order: 12,
      },
    ];
    if (this.typeModal === 'edit') {
      this.modelDisplay = [
        ...this.modelDisplay,
        {
          key: 'apikey',
          label: 'ApiKey',
          type: FormFieldType.Text,
          value: this.model.apikey,
          required: true,
          disabled: true,
          width: '1/2',
          order: 13,
        },
        {
          key: 'secretkey',
          label: 'SecretKey',
          type: FormFieldType.Text,
          value: this.model.secretkey,
          required: true,
          disabled: true,
          width: '1/2',
          order: 14,
          reload: true,
        },
      ];
    }
    this.modelDisplay = [
      ...this.modelDisplay,
      {
        key: 'is_call',
        label: 'Cho phép nghe gọi',
        type: FormFieldType.Switch,
        value: this.model.is_call,
        required: false,
        disabled: false,
        width: '1/2',
        order: 15,
        options: {
          checkInline: true,
        },
      },
      {
        key: 'is_auto',
        label: 'Cấu hình tự động',
        type: FormFieldType.Switch,
        value: this.model.is_auto,
        required: false,
        disabled: this.typeModal !== 'add',
        width: '1/2',
        order: 16,
        options: {
          checkInline: true,
        },
      },
    ];
  }

  isInteger(x) {
    return parseInt(x, 10) == x;
  }

  async add() {
    const payload = {
      name: this.model.name,
      email: this.model.email,
      domain: this.model.domain,
      limited: this.model.limited ? parseFloat(this.model.limited) : 5,
      max_inbound: this.model.max_inbound ? parseFloat(this.model.max_inbound) : null,
      max_outbound: this.model.max_outbound ? parseFloat(this.model.max_outbound) : null,
      inbound_duration: this.model.inbound_duration ? parseFloat(this.model.inbound_duration) : null,
      outbound_duration: this.model.outbound_duration ? parseFloat(this.model.outbound_duration) : null,
      duration: this.model.duration ? parseFloat(this.model.duration) : null,
      ring_duration: this.model.ring_duration ? parseFloat(this.model.ring_duration) : null,
      max_duration_out: this.model.max_duration_out ? parseFloat(this.model.max_duration_out) : null,
      webhook: this.model.webhook,
      crmurl: this.model.crmurl,
      is_call: this.model.is_call,
      is_auto: this.model.is_auto,
      apikey: generateKey(32),
      secretkey: generateKey(32),
    };
    this.accountService.create(payload).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          if (res.data.report) {
            this.downloadFileAgent(res.data.report);
          }
          this.throwSuccess('Thêm mới thành công!');
          this.loadData();
          this.closeModal();
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  async active(id, status) {
    if (status === undefined || status === null) {
      status = true;
    }
    this.accountService.active(id, { active: status }).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.is_loading = true;
          setTimeout(() => {
            this.throwSuccess(status ? 'Kích hoạt thành công!' : 'Dừng hoạt động thành công!');
            this.loadData();
            this.is_loading = false;
          }, 1000);
        } else {
          this.throwError(res.message);
        }
      },
      error => {
        this.throwError(error.message);
      }
    );
  }

  async downloadFileAgent(base64data, filename = 'Danh sách chuyên viên!') {
    const binaryString = atob(base64data);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);

    for (let i = 0; i < binaryLen; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    const blob = new Blob([bytes], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, filename);
  }

  async edit() {
    const _id = this.model._id;
    const payload = {
      name: this.model.name,
      email: this.model.email,
      domain: this.model.domain,
      limited: this.model.limited ? parseFloat(this.model.limited) : 5,
      max_inbound: this.model.max_inbound ? parseFloat(this.model.max_inbound) : null,
      max_outbound: this.model.max_outbound ? parseFloat(this.model.max_outbound) : null,
      inbound_duration: this.model.inbound_duration ? parseFloat(this.model.inbound_duration) : null,
      outbound_duration: this.model.outbound_duration ? parseFloat(this.model.outbound_duration) : null,
      duration: this.model.duration ? parseFloat(this.model.duration) : null,
      ring_duration: this.model.ring_duration ? parseFloat(this.model.ring_duration) : null,
      max_duration_out: this.model.max_duration_out ? parseFloat(this.model.max_duration_out) : null,
      webhook: this.model.webhook,
      crmurl: this.model.crmurl,
      is_call: this.model.is_call,
      is_auto: this.model.is_auto,
      apikey: this.model.apikey,
      secretkey: this.model.secretkey,
    };
    this.accountService.update(_id, payload).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.throwSuccess('Cập nhật thành công!');
          this.loadData();
          this.closeModal();
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  async search() {
    this.currentPage = 1;
    if (this.modelFilter.keyword && this.modelFilter.keyword.trim() != '') {
      await this.loadData({ name: this.modelFilter.keyword });
    } else {
      await this.loadData();
    }
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);
      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  async handleAction(type: any, item?: any) {
    this.model = {};
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-lg',
      keyboard: false,
    };
    switch (type) {
      case TableAction.add:
        this.model.is_call = 1;
        this.model.is_auto = 1;
        await this.setUpModel('add');
        this.openModal(this.templateAccount, config, this.model, {
          modelContent: this.modelContent,
          modelDisplay: this.modelDisplay,
        });
        break;
      case TableAction.edit:
        Object.keys(item).forEach(key => {
          if (item[key] !== null && item[key] !== undefined) {
            this.model[key] = item[key];
          }
        });
        await this.setUpModel('edit');
        this.openModal(this.templateAccount, config, this.model, {
          modelContent: this.modelContent,
          modelDisplay: this.modelDisplay,
        });
        break;
      case TableAction.config:
        this.targetTenant = item;
        this.isConfig = true;
        break;
      case TableAction.active:
        await this.active(item._id, item.status);
        break;
    }
  }

  async handleSubmit(item?: any) {
    this.model = _.merge({}, this.model, item);
    if (this.typeModal === 'add') {
      await this.add();
    } else if (this.typeModal === 'edit') {
      await this.edit();
    }
  }

  async onChangeValueModel(key, item?: any) {
    this.message = null;
    this.model = _.merge({}, this.model, item);
    switch (key) {
      case 'email':
        if (!isEmail(item[key])) {
          this.message = {
            class: 'alert dark alert-danger',
            content: 'Email không hợp lệ!',
          };
        }
        break;
    }
    await this.setUpModel(this.typeModal);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/account/account.component.ts